import { useEffect } from "react";
import { useTranslation } from "../../../../hooks";
import { Button } from "../../../../components/ui/Buttons/Button/Button";
import { IPV4_DOC_PATH } from "../../../../utils/constants";
import { Main } from "./Main/Main";
import "./Documentation.scss";

export const Documentation = () => {
  const controller = new AbortController();

  const { cabinet: { documentation: { main: { documentation, readDocumentation } } } } = useTranslation();

  useEffect(() => () => controller.abort()
      // eslint-disable-next-line react-hooks/exhaustive-deps
  , []);

  const handleDocButton = () => {
    window?.open(IPV4_DOC_PATH, "_blank");
  };

  return (
    <>
      <Main controller={controller}/>
      <div className="documentation__contain">
        <div className="documentation__row documentation__row--documentation">
          <div className="documentation__title">{documentation}</div>
          <Button tab="confirm" onClick={handleDocButton}>
            {readDocumentation}
          </Button>
        </div>
      </div>
      {/*<DescriptionsAPI />*/}
    </>
      );
      };
